import React from "react";
import Icon from "@/theme/vectors/bundle";
import { getFileTypeCategory, VALID_FILENAME_PATTERN } from "./constants";

// Get icon for media type
export const getMediaTypeIcon = (type) => {
    switch(type) {
        case 'image':
            return <Icon name="image" size={24} />;
        case 'video':
            return <Icon name="video" size={24} />;
        case 'audio':
            return <Icon name="audio" size={24} />;
        case 'pdf':
            return <Icon name="document" size={24} />;
        case 'text/plain':
            return <Icon name="text" size={24} />;
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return <Icon name="word" size={24} />;
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return <Icon name="excel" size={24} />;
        default:
            return <Icon name="file" size={24} />;
    }
};

// Format file size
export const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Get file type display with translation support
export const getFileTypeDisplay = (mimeType, t) => {
    const category = getFileTypeCategory(mimeType);
    const translatedCategory = t ? t(`product.detail.fileTypeCategory.${category}`, category.toLowerCase()) : category.toLowerCase();
    return `${translatedCategory}: ${mimeType}`;
};

// Validate filename against pattern
export const isValidFilename = (filename) => {
    return VALID_FILENAME_PATTERN.test(filename);
};

// Get formatted validation message for filename
export const getFilenameValidationMessage = (filename, t = null) => {
    if (!filename) return "";
    
    const invalidChars = [];
    
    // Check for spaces
    if (filename.includes(' ')) invalidChars.push(t ? t('product.detail.spaces', 'spaces') : 'spaces');
    
    // Check for non-ASCII characters (like Vietnamese accented characters)
    if (/[^\x00-\x7F]/.test(filename)) invalidChars.push(t ? t('product.detail.nonEnglishChars', 'non-English characters') : 'non-English characters');
    
    // Check for special characters other than - and _
    if (/[^\w\d\-_.]/.test(filename)) invalidChars.push(t ? t('product.detail.specialChars', 'special characters') : 'special characters');
    
    if (invalidChars.length === 0) return "";
    
    return t 
        ? t('product.detail.invalidCharsDetected', { chars: invalidChars.join(', ') }) 
        : `Invalid characters detected: ${invalidChars.join(', ')}`;
};